import Axios from "axios"
import { HEADER_WEB_VERSION } from "./cdn"

export const axios = Axios.create({
	headers: {
		"Web-Version": HEADER_WEB_VERSION,
	},
})
